import { NavigationGuard } from 'vue-router'

import useAuthStore from '@/store/auth.store'

const guard: NavigationGuard = async (to, _, next) => {
  const store = useAuthStore()

  const authorized = await store.authenticate()

  if (authorized) return next()

  if (process.env.VUE_APP_DASHBOARD_LOGIN_URL === undefined) return

  window.location.href = `${process.env.VUE_APP_DASHBOARD_LOGIN_URL}?redirect=${window.location.href}`
}

export default guard
